import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-xl text-white mb-4">
              <span className="text-primary-400">尾巴漫画</span>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              尾巴漫画网提供海量免费韩国漫画在线畅读，每日更新最新高清韩漫。支持便捷的下拉式观看模式，带来极致流畅的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门推荐</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">恋爱言情</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">奇幻冒险</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">动作热血</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-4">更多分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/mystery" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑推理</Link></li>
              <li><Link to="/category/bl" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">耽美BL</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">搞笑日常</Link></li>
              <li><Link to="/category/latest" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新上架</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-foreground-200 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-foreground-200 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-foreground-200 hover:text-white transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 尾巴漫画网 版权所有 | 免费韩国漫画在线阅读平台
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}